import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { useClipQualitySettingsModal } from "MVVM/Hooks/useClipQualitySettingsModal";
import { usePortal } from "MVVM/Hooks/usePortal";
import { UnifiedUpgradeModal } from "MVVM/Components/Modals/UnifiedUpgradeModal";
import { TTierKey } from "MVVM/Views/Pricing/Components/PricingCards/types";
import { ClipQualitySettingsModal } from "./index";

const MODAL_QUERY_PARAM = "clip-quality-settings";

export const ClipQualitySettingsModalRenderer = () => {
  const { isOpen, open, close } = useClipQualitySettingsModal();
  const [upgradeTier, setUpgradeTier] = useState<TTierKey>("PRO");

  const {
    portalOpen: upgradeModalOpen,
    setPortalOpen: setUpgradeModalOpen,
    Portal: UpgradeModalPortal,
  } = usePortal(
    <UnifiedUpgradeModal
      featureName="Higher Quality Clips"
      upgradeAction="Get higher quality clips"
      requiredTierKey={upgradeTier}
      analyticsSource="Clip Quality Settings"
      initialPlan={upgradeTier}
      onClose={() => setUpgradeModalOpen(false)}
    />,
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.has(MODAL_QUERY_PARAM)) {
      open();

      params.delete(MODAL_QUERY_PARAM);
      const remaining = params.toString();
      const newUrl =
        window.location.pathname + (remaining ? `?${remaining}` : "");
      window.history.replaceState({}, "", newUrl);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUpgradeRequired = (tierKey: string) => {
    setUpgradeTier(tierKey as TTierKey);
    close();
    setTimeout(() => setUpgradeModalOpen(true), 150);
  };

  return (
    <>
      {isOpen &&
        createPortal(
          <ClipQualitySettingsModal
            onClose={close}
            onUpgradeRequired={handleUpgradeRequired}
          />,
          document.getElementById("root") || document.body,
        )}
      {upgradeModalOpen && UpgradeModalPortal}
    </>
  );
};
